module.exports = __webpack_public_path__ + "img/10864_L.5a90bb1e.png";